import { render, staticRenderFns } from "./activities-table.vue?vue&type=template&id=2b13e8a0&scoped=true"
import script from "./activities-table.ts?vue&type=script&lang=ts&external"
export * from "./activities-table.ts?vue&type=script&lang=ts&external"
import style0 from "./activities-table.scss?vue&type=style&index=0&id=2b13e8a0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13e8a0",
  null
  
)

export default component.exports